import React, { useEffect, useState } from "react";
import Loader from "../../components/loader/Loader";
import { getAllProducts, getAllUsers } from "../../../services/Admin";
import formatDate from "../../../utils/formatDate";
import CustomTable from "../../components/custom-table/CustomTable";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

function AllProducts() {
  const [isLoading, setIsLoading] = useState(true);
  const [allMemberDetails, setAllMemberDetails] = useState([]);

  const columns = [
    {
      Header: "S.no",
      accessor: "sno",
    },
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Main Image",
      accessor: "imagesrc",
    },
    {
      Header: "Varient Bar Code",
      accessor: "variantBarcode",
    },
  ];

  const fetchAllProducts = async () => {
    try {
      const response = await getAllProducts();
      const products = response.products;
      console.log(products);

      const newArr = products.map((entry, index) => ({
        sno: index + 1,
        title: entry.title,
        imagesrc:
          entry.imageSrc && entry.imageSrc[0] ? (
            <img width="100px" src={entry.imageSrc[0]} alt={entry.handle} />
          ) : "null",
          variantBarcode: entry.variantBarcode || "-"
      }));
      setAllMemberDetails(newArr);
    } catch (error) {
      console.log(error);
      toast.error("Something Went wrong!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllProducts();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="investment-history">
          <h1 className="main-heading">All Products</h1>
          <br />
          <br />

          <CustomTable
            data={allMemberDetails}
            columns={columns}
            heading="All Products details"
          />
        </div>
      )}
    </>
  );
}

export default AllProducts;
